import { AppAvatar, AppBox, AppPaper, AppText, AppTitle } from "../../../../commons/components";

import AppBorderBox from "../../../../commons/components/BorderBox";
import IllustrationBadge from "../../../../commons/components/illustrations/illustrationBadge";
import { IFootballAward } from "../../../../commons/models/football/interface/i-football-award";
import { IFootballPlayerDetail } from "../../../../commons/models/football/interface/i-football-player";
import { SurfaceColor } from "../../../../commons/types/core-types";
import { formatDate } from "../../../../commons/utilities/date-utils";
import { toSentenceCase, toTitleCase } from "../../../../commons/utilities/string-utils";

interface PlayerAwardCardProps {
  player: IFootballPlayerDetail;
  award: IFootballAward;
}

export default function PlayerAwardCard({ player, award }: PlayerAwardCardProps) {
  return (
    <AppPaper className="best-player-card" padding="xs" shadow="xs">
      <AppBorderBox border={["Bottom"]} pb="2xs">
        <AppBox justifyContent="space-between">
          <AppBox gap="2xs" alignItems="center">
            <AppAvatar size="md" src={player.avatar || ""} username={player.fullName} />
            <AppBox flexDirection="column">
              <AppTitle as="h6">{toTitleCase(player.displayName)}</AppTitle>
              <AppText as="label" size="sm">
                {toSentenceCase(player.additionalInfo?.position || "")}
              </AppText>
            </AppBox>
          </AppBox>
          <AppAvatar
            size="xs"
            src={player.additionalInfo?.team.logo || ""}
            username={player.additionalInfo?.team.shortName || "Team"}
          />
        </AppBox>
      </AppBorderBox>
      <AppBox justifyContent="center" gap="2xs" py="2xs">
        <AppText>Date: {formatDate(award.receivedDate, "DD MMM, YYYY")}</AppText>
      </AppBox>
      <AppPaper radius="sm" bgColor={SurfaceColor.surface3} padding="none">
        <AppBox p="2xs" gap="3xs" justifyContent="center" alignItems="center" flexDirection="row">
          <AppBox>
            <IllustrationBadge width="24" height="24" />
          </AppBox>
          <AppTitle as="h6" color="accent" lineClamp={1}>
            {award.title}
          </AppTitle>
        </AppBox>
      </AppPaper>
    </AppPaper>
  );
}
